import React, { useEffect } from 'react';
import { Grid, Typography, Divider, TextField } from '@mui/material';
import InputField from 'components/formFields/InputField';
import DatePickerField from 'components/formFields/datePickerField';
import suscripcionesFormModel from '../../formik/suscripcionesFormModel';
import AutocompleteField from 'components/formFields/autocompleteField';
import SelectField from 'components/formFields/selectField';
import { useDispatch, useSelector } from 'react-redux';
import { useFormikContext } from 'formik';

const statusOptions = [
  { label: 'Activa', value: 'ACTIVE' },
  { label: 'Suspendida', value: 'SUSPENDED' },
  { label: 'Vencida', value: 'EXPIRED' },
  { label: 'Cancelada', value: 'CANCELED' },
];

const renewalTypeOptions = [
  { label: 'Manual', value: 'MANUAL' },
  { label: 'Automática', value: 'AUTOMATIC' },
];

export const SuscripcionesForm = ({ formField, isEditing = false }: any) => {
  const dispatch: any = useDispatch();
  const { suscriptions_for_select, customer_for_select } = useSelector(
    (state: any) => state.servicesIaSuscriptions
  );
  const { values, setFieldValue } = useFormikContext<any>();

  useEffect(() => {
    if (values?.expiresAt && values?.expiresAt !== values?.nextRenewalAt) {
      setFieldValue('nextRenewalAt', values.expiresAt);
    }
  }, [values?.expiresAt, setFieldValue, values?.nextRenewalAt]);

  const planIdSeleccionado =
    typeof values?.planId === 'object' ? values?.planId?.value : values?.planId;
  const planSeleccionado =
    suscriptions_for_select.find(
      (p: any) => p.value === planIdSeleccionado || p.id === planIdSeleccionado
    ) || (typeof values?.planId === 'object' ? values.planId : null);

  useEffect(() => {
    if (values?.startsAt && planSeleccionado?.duration) {
      const [year, month, day] = values.startsAt.split('-').map(Number);
      const startDate = new Date(year, month - 1, day);

      startDate.setDate(startDate.getDate() + Number(planSeleccionado.duration));

      const newYear = startDate.getFullYear();
      const newMonth = String(startDate.getMonth() + 1).padStart(2, '0');
      const newDay = String(startDate.getDate()).padStart(2, '0');
      const expiresDateStr = `${newYear}-${newMonth}-${newDay}`;

      setFieldValue('expiresAt', expiresDateStr);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [values.startsAt, planSeleccionado?.duration, setFieldValue]);

  const { customerId, planId, statusSuscription, startsAt, expiresAt, renewalType, nextRenewalAt } =
    suscripcionesFormModel.formField;

  return (
    <Grid container spacing={3}>
      {/* Sección de Información Básica */}
      <Grid size={{ xs: 12 }}>
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Información Básica
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <AutocompleteField
          name={customerId.name}
          label={customerId.label}
          options={customer_for_select}
          fullWidth
          disabled={isEditing}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <AutocompleteField
          name={planId.name}
          label={planId.label}
          options={suscriptions_for_select}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <SelectField
          name={statusSuscription.name}
          label={statusSuscription.label}
          data={statusOptions}
          fullWidth
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <DatePickerField
          name={startsAt.name}
          label={startsAt.label}
          fullWidth
          disabled={isEditing}
        />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <DatePickerField name={expiresAt.name} label={expiresAt.label} fullWidth />
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <SelectField
          name={renewalType.name}
          label={renewalType.label}
          data={renewalTypeOptions}
          fullWidth
        />
      </Grid>

      {/* Información del Plan (Solo lectura) */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Información del Plan
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Precio"
          value={planSeleccionado?.price || ''}
          fullWidth
          inputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Moneda"
          value={planSeleccionado?.currency || ''}
          fullWidth
          inputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Créditos Mensuales"
          value={planSeleccionado?.monthlyCredits || ''}
          fullWidth
          inputProps={{
            readOnly: true,
          }}
        />
      </Grid>
      <Grid size={{ xs: 12, md: 6 }}>
        <TextField
          label="Duración (Días)"
          value={planSeleccionado?.duration || ''}
          fullWidth
          inputProps={{
            readOnly: true,
          }}
        />
      </Grid>

      {/* Información de Créditos */}
      <Grid size={{ xs: 12 }}>
        <Divider sx={{ my: 1 }} />
        <Typography variant="subtitle1" fontWeight={600} mb={1}>
          Información de Créditos
        </Typography>
      </Grid>

      <Grid size={{ xs: 12, md: 6 }}>
        <DatePickerField name={nextRenewalAt.name} label={nextRenewalAt.label} fullWidth readOnly />
      </Grid>
    </Grid>
  );
};
